var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.text)?_c('div',[_c('canvas',{attrs:{"id":"myChart47","width":"30","height":"10"}})]):_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }